import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import { useHistory } from 'react-router-dom';
import { getIsTransitionOrBundleCredit, isPortalWithClonedPostings } from '@panel/commons/helpers';
import OptionsSelector from '@panel/commons/lib/DropDown/OptionSelector';
import BackButton from '@panel/commons/lib/BackButton';
import ExternalIcon from '@panel/commons/assets/icons/external-grey.svg';
import PreviewBlack from '@panel/commons/assets/icons/PreviewBlack.svg';

const ButtonPanel = ({ device, posting = {} }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isDesktop = device === 'desktop';
  const { urlPosting, status, publicationPlanId } = posting;
  const isOnline = ['ONLINE', 'NEAR_END'].includes(status);
  const hasSelectorPosting =
    getIsTransitionOrBundleCredit(parseInt(publicationPlanId)) && isOnline && isPortalWithClonedPostings;
  const positionSelectRef = useRef(null);
  const redirectUrl = `${window.location.origin}/${t('panel.url.property')}/${urlPosting}`;
  const [showSelectPosting, setShowSelectPosting] = useState(false);

  const redirectToPosting = hasMirror => {
    if (hasMirror) {
      window.open(`${redirectUrl}?mirror=true`, '_blank');
      sendCustomTrackingInfo({
        event: 'select_content',
        content_group: 'Panel',
        content_type: 'Mis avisos',
        item_id: 'Consultar aviso secundario'
      });
    } else {
      window.open(redirectUrl, '_blank');
      sendCustomTrackingInfo({
        event: 'select_content',
        content_group: 'Panel',
        content_type: 'Mis avisos',
        item_id: 'Consultar aviso'
      });
    }
    setShowSelectPosting(false);
  };

  const optionsPostingsArray = [
    { text: t('posting.card.goToPrincipalPosting'), handleOnClick: () => redirectToPosting(), id: '01' },
    { text: t('posting.card.goToClonedPosting'), handleOnClick: () => redirectToPosting(true), id: '02' }
  ];

  const handleOutsideClick = onElement => {
    if (onElement) {
      setShowSelectPosting(false);
    }
  };

  const onViewPostingButtonPress = e => {
    e.stopPropagation();
    if (!hasSelectorPosting) {
      window.open(redirectUrl, '_blank');
      sendCustomTrackingInfo({
        event: 'select_content',
        content_group: 'Panel',
        content_type: 'Mis avisos',
        item_id: 'Consultar aviso'
      });
    }
    if (hasSelectorPosting) setShowSelectPosting(!showSelectPosting);
  };

  const getPostingSelector =
    hasSelectorPosting && showSelectPosting ? (
      <OptionsSelector
        isOpen={showSelectPosting}
        optionsArray={optionsPostingsArray}
        elementRef={positionSelectRef}
        handleOutsideClick={handleOutsideClick}
        height='94px'
        topDown='60px'
        left='unset'
        right={isDesktop ? '0px' : '16px'}
      />
    ) : null;

  const actionItems = {
    desktop: [
      {
        id: 'goToPosting',
        icon: ExternalIcon,
        onClick: onViewPostingButtonPress,
        backSize: '20px',
        text: t('postings.card.OptionsMenu.goToPosting'),
        separator: 'preIcon',
        gapSeparator: '16px',
        children: getPostingSelector,
        disabledTooltip: showSelectPosting
      }
    ],
    // Elementos para mobile o tablet:
    mobile: [
      {
        id: 'goToPosting',
        icon: PreviewBlack,
        onClick: onViewPostingButtonPress,
        backSize: '23px',
        text: t('postings.card.OptionsMenu.goToPosting'),
        children: getPostingSelector,
        disabledTooltip: showSelectPosting
      }
    ]
  };

  return (
    <BackButton
      device={device}
      useHistory={history}
      backButtonText={t('panel.desempeno.atras')}
      newItems={actionItems}
      showDataLayer={() =>
        sendCustomTrackingInfo({
          event: 'select_content',
          content_group: 'Panel',
          content_type: 'Mis avisos',
          item_id: 'Volver atrás'
        })
      }
    />
  );
};

ButtonPanel.propTypes = {
  device: PropTypes.string.isRequired
};

export default ButtonPanel;
